<ng-template #patternInfoPopover>
  <adm4-pattern-info-popover
    [pattern]='pattern'
    [patternType]='patternType'
  [bundleKey]="pattern.bundleKey"></adm4-pattern-info-popover>
</ng-template>
<div class='full-height'>
  @if (form) {
  <form class='full-height-flex' [formGroup]='form' (ngSubmit)='onFormSubmit.next(form.value)'>
    <adm4-column-header [styleClass]="headerStyle">
      <div class="pattern-title-wrapper">
        <div class='pattern-icon-container'>
          <div class='pattern-icon'
            [ngClass]='patternTypeIconClass'
            [ngbTooltip]='patternInfoPopover' placement='right'>
          </div>
        </div>
        @if (!headerEditMode) {
          <span (click)="onRenamePattern()" class='title' [title]='headerTitle'>{{headerTitle}}</span>
          @if (pattern.label) {
            <mat-icon [ngbTooltip]='labelPopover' class='label-icon' placement='bottom-right'>
            local_offer</mat-icon>
          }
          <ng-template #labelPopover><p>Labelled as: <strong>{{pattern.label}}</strong></p>
          <p>Switch to <a (click)='switchToLabelView()'>Label view</a> to group the patterns by the labels.</p></ng-template>
        } @else {
          <adm4-editable-text
            fcName="pattern_name"
            [form]="form"
            styleClass="headerTitle"
            (focusLost)="onHeaderBlur()">
          </adm4-editable-text>
        }
        <adm4-pattern-menu
          [readOnly]='readOnly'
          [pattern]="pattern"
          [allPatternLabels]='patternLabels$ | async'
          [icon]="headerEditMode ? 'edit' : 'more_vert'"
          [projectKey]='projectKey'
          (copy)="onCopyPattern()"
          (rename)="onRenamePattern()"
        (duplicate)="onDuplicatePattern()"></adm4-pattern-menu>
        @if (isHelpCollapsed) {
          <adm4-toggle-collapse-button
            side='right'
            buttonClass='admn4-button-icon-white'
            [isCollapsed]='isHelpCollapsed'
            (keydown.enter)='$event.stopPropagation()'
            (click)='onHelpExpanderClick()'
          ></adm4-toggle-collapse-button>
        }
      </div>
    </adm4-column-header>
    <div class='remaining-space-flex-content-wrapper'>
      <div class='remaining-space-flex-content'>
        <div class='pr-property-container full-height-flex' #scrollArea>
          <adm4-pattern-issue-list
          [issues]="patternIssues$ | async" [patternLinkInfo]='pattern?.link'></adm4-pattern-issue-list>
          <div class='pr_list ui_list'>
            @if (!noProperties) {
              <mat-tab-group class='full-height mat-tabs-full-height' [mat-stretch-tabs]='false'
                [selectedIndex]='categoryIndex$ | async'
                (focusChange)='selectPropertyCategoryByIndex($event.index)'>
                @for (propertyModelCategoryGroup of propertyModelCategoryGroups; track propertyCategoryGroupTrackBy($index, propertyModelCategoryGroup)) {
                  <mat-tab>
                    <ng-template mat-tab-label>
                      <div class='category-group-label'>
                        @if (propertyCategoryGroupHasIssues(propertyModelCategoryGroup)) {
                          <adm4-highest-severity-issue-indicator
                            [diameter]='10'
                            [issues]='getIssuesOfPropertyCategoryGroup(propertyModelCategoryGroup)'
                          ></adm4-highest-severity-issue-indicator>
                        }
                        <span>{{propertyModelCategoryGroup.category}}</span>
                      </div>
                    </ng-template>
                    @if (isDefaultPropertyModelCategoryGroup(propertyModelCategoryGroup)) {
                      <div #deploymentHost>
                        @if (patternType && patternType.deployablePattern && !shouldBeRestricted(pattern?.displayOptions?.hidden, "field.deploymentHosts")) {
                          <adm4-deployment-host
                            [form]='form'
                            [fcName]='deploymentHostsFormControlName'
                            [readOnly]='readOnly || shouldBeRestricted(pattern?.displayOptions?.readOnly, "field.deploymentHosts")'
                            [issues]='deploymentHostIssues'>
                          </adm4-deployment-host>
                        }
                      </div>
                    }
                    <adm4-property-list [propertiesModel]='propertyModelCategoryGroup.propertiesModel'
                      [pattern]='pattern'
                      [projectKey]='projectKey'
                      [variables]='variables'
                      [selectedPropertyKey]='selectedPropertyKey'
                      [form]='form'
                      [readOnly]='readOnly'
                      [scrollArea]='scrollArea'
                      (selectProperty)='changeSelectedProperty($event)'
                      (validate)='triggerValidation($event)'
                    ></adm4-property-list>
                  </mat-tab>
                }
              </mat-tab-group>
            }
            @if (noProperties) {
              <div class="noProperties">
                {{NO_PROPERTIES_LABEL}}
              </div>
            }
          </div>
        </div>
      </div>
    </div>
    @if (!shouldBeRestricted(pattern?.displayOptions?.hidden, "field.notes")) {
      <adm4-pattern-notes class='floating-container'
        [form]='form'
        [fcName]="patternNotesFormControlName"
        [readOnly]='readOnly || shouldBeRestricted(pattern?.displayOptions?.readOnly, "field.notes")'
        [isPatternNotesCollapsed]='isPatternNotesCollapsed$ | async'
        (patterNoteCollapse)='updatePatternNotesCollapseState($event)'>
      </adm4-pattern-notes>
    }
    @if (!readOnly) {
      <adm4-button-bar
        [isSubmitDisabled]="formActionsDisabled"
        [isCancelDisabled]='formActionsDisabled'
        [cancelButtonText]='"Reset"'
        [wrapperClass]='"admn4-buttons-wrapper"'
      (cancelClicked)='resetForm()'></adm4-button-bar>
    }
  </form>
  }
</div>
